const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Menu = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domMenuBtn: $('.js-menu-btn'),
	$domMenuOuter: $('.js-nav-outer'),
	$domMenuInner: $('.js-nav-inner'),
	$domSubMenuInitBtn: $('.js-submenu-init'),
	$domSubMenu: $('.js-submenu'),
	classActive: 'is-active',
	timeout: null,

	/** @description Initialize */
	init: function() {
		if (window.innerWidth < 1200) {
			this.bindEvents();
		}
	},

	/** @description Bind Events */
	bindEvents: function() {
		this.$domMenuBtn.on('click', this.toggleMenu.bind(this));
		this.$domSubMenuInitBtn.on('click', this.toggleSubMenu.bind(this));
		Global.escKey(this.closeMenu.bind(this));
		Global.clickOutsideContainer(Global.$domBody, this.$domMenuInner, this.$domMenuBtn, this.closeMenu.bind(this));
	},

	toggleMenu: function() {
		if (!this.$domMenuBtn.hasClass(this.classActive)) {
			this.$domMenuBtn.addClass(this.classActive);
			this.$domMenuOuter.addClass(this.classActive);
		} else {
			this.closeMenu();
		}
	},

	toggleSubMenu(e) {
		const $clickedSubMenuBtn = $(e.currentTarget);
		const $submenu = $clickedSubMenuBtn.next(this.$domSubMenu);

		// Close any open submenus
		this.$domSubMenuInitBtn.not($clickedSubMenuBtn).removeClass(this.classActive);
		this.$domSubMenu.not($submenu).slideUp();

		// Toggle the clicked submenu
		if (!$clickedSubMenuBtn.hasClass(this.classActive)) {
			$clickedSubMenuBtn.addClass(this.classActive);
			$submenu.slideDown();
		} else {
			$clickedSubMenuBtn.removeClass(this.classActive);
			$submenu.slideUp();
		}
	},

	closeMenu: function() {
		this.$domMenuBtn.removeClass(this.classActive);
		this.$domMenuOuter.removeClass(this.classActive);

		// timeout should match the selectors CSS transition duration property
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.$domSubMenuInitBtn.removeClass(this.classActive);
			this.$domSubMenu.slideUp();
		}, 250);
	}
};

export default Menu;
